import { Outlet, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import CreatePopup from './create/CreatePopup';
import PersistentBalanceChip from './PersistentBalanceChip';
import { hapticImpact, hapticSelection } from '../utils/haptics';
import { useConsentStore } from '../store/consentStore';

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const popupOpen = searchParams.get('create') === '1';
  const isPromptPage = location.pathname.startsWith('/prompt');
  const isSearchPage = location.pathname === '/search';
  const isHomeRubricDetailPage = location.pathname.startsWith('/photo-catalog/section/');
  const consentRequired = useConsentStore((state) => state.consentRequired);
  const isGalleryWelcome =
    location.pathname === '/gallery' && consentRequired === true;

  useLayoutEffect(() => {
    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
      try {
        window.scrollTo(0, 0);
      } catch {
        /* non-fatal in tests */
      }
    }
  }, [location.pathname]);

  const closePopup = () => {
    hapticImpact('light');
    const params = new URLSearchParams(searchParams);
    params.delete('create');
    const qs = params.toString();
    navigate(qs ? `${location.pathname}?${qs}` : location.pathname, { replace: true });
  };

  const pickPhoto = () => {
    hapticSelection();
    closePopup();
    navigate('/photo-catalog');
  };

  const pickVideo = () => {
    hapticSelection();
    closePopup();
    navigate('/video-catalog');
  };

  return (
    <>
      {!isSearchPage && !isHomeRubricDetailPage && (
        <PersistentBalanceChip forceLogo={isGalleryWelcome} />
      )}
      <div
        className="min-h-screen bg-bg-app"
        style={
          isPromptPage || isGalleryWelcome || isHomeRubricDetailPage
            ? undefined
            : { paddingBottom: 'calc(var(--safe-bottom, 0px) + 96px)' }
        }
      >
        <Outlet />
        <CreatePopup
          open={popupOpen}
          onClose={closePopup}
          onPickPhoto={pickPhoto}
          onPickVideo={pickVideo}
        />
      </div>
    </>
  );
}
